module.exports = __webpack_public_path__ + "static/img/2.20791f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/04/2.png
// module id = voV+
// module chunks = 1